import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from './messages';
import style from './style.module.css';
import { useEditRecipientTaxIdentifiersFormContext } from '../order-details/fulfillment-plan/sections/shipment-details/tax-identifier/edit-tax-identifiers/context';

/**
 * @typedef {import('ui-components/components/button').ButtonClickHandler} ButtonClickHandler
 */

/**
 * @param {object} props
 * @param {ButtonClickHandler} props.onCancel - callback to be executed when clicking on cancel button or when saving data
 * @returns {JSX.Element} The rendered TaxInfoFooter
 */
export const TaxInfoFooter = ({ onCancel }) => {
  const { saveTaxIdentifier } = useEditRecipientTaxIdentifiersFormContext();

  const handleOnClick = useCallback(async () => {
    const didSucceed = await saveTaxIdentifier();
    if (didSucceed) {
      onCancel();
    }
  }, [onCancel, saveTaxIdentifier]);

  return (
    <div className={style['button-row']}>
      <Button className={style['add-margin']} onClick={onCancel} theme='tertiary'>
        <FormattedMessage {...messages.cancel} />
      </Button>
      <Button onClick={handleOnClick} theme='primary'>
        <FormattedMessage {...messages.save} />
      </Button>
    </div>
  );
};
